import _ from 'lodash';
import Dailymotion from 'react-dailymotion';
import { useEffect, useState } from 'react';
import CardH from 'src/components/cards-video/card-h';
import { APP_IMG } from 'src/constants';

const SecFullHEnergy = ({ data = [], eventDataLayer }) => {
  const [defalutData, setDefalutData] = useState({
    video_type: '',
    video_src: ''
  });
  const dataSetVideo = [data?.block1, data?.block2, data?.block3];
  const [counter, setCounter] = useState(0);
  const dataItem = dataSetVideo[0];

  useEffect(() => {
    if (dataItem.data?.length > 0) {
      setDefalutData({ video_type: dataItem.data[0]?.type_video, video_src: dataItem.data[0]?.video_src });
    }
  }, [dataItem]);

  const getVideoIframe = () => {
    let urlVideo;
    if (defalutData.video_type === '0') {
      urlVideo = `${APP_IMG}/${defalutData.video_src}`;
    } else if (defalutData.video_type === '2') {
      urlVideo = defalutData.video_src;
    } else {
      urlVideo = defalutData.video_src;
    }
    return (
      <>
        {defalutData.video_type === '4' ? (
          <div dangerouslySetInnerHTML={urlVideo} />
        ) : (
          <>
            {defalutData.video_type === '2' ? (
              <iframe id='video-frame-section' className='video-frame' src={`${urlVideo}?autoplay=0&mute=1`} frameBorder='0' />
            ) : (
              <div className='video-div-energy'>
                <Dailymotion
                  video={urlVideo}
                  width={640}
                  height={480}
                  theme='dark'
                  autoplay={false}
                  // paused={statusChange}
                />
              </div>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <>
      {!_.isEmpty(dataSetVideo) && (
        <>
          <div className='section-wrapper'>
            <div className='row'>
              <div className='col-12 video-player-energy'>{!_.isEmpty(dataItem?.data) && getVideoIframe()}</div>
              <div className='col-12 card-wrapper-live'>
                <div className='video-playlists playlist-custom-scroll-energy --vertical'>
                  <ul>
                    {!_.isEmpty(dataItem?.data) &&
                      dataItem.data.map((item, index) => (
                        <li
                          className={`w-100 ${counter === index ? 'active' : ''}`}
                          key={index}
                          onClick={() => {
                            setDefalutData({ video_type: item.type_video, video_src: item.video_src });
                            setCounter(index);
                          }}
                        >
                          <CardH
                            data={item}
                            number={index + 1}
                            //! DATALAYER
                            eventDataLayer={{
                              ...eventDataLayer,
                              data: {
                                ...eventDataLayer?.data,
                                title: item?.title,
                                index: index + 1
                              }
                            }}
                          />
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SecFullHEnergy;
